export const RecentActivitys =[
   {
      title:"Any desktop publishing pack ages editors.",
      hours:"16 Apr 2023 | 11 hours ago",
      butclassname:"primary"
   },
   {
      title:"Renewed account with this new premium plan popular belief.",
      hours:"20 Mar 2023 | 14 hours ago",
      butclassname:"secondary"
   },
   {
      title:"Micron to build largest chip factory in US history will distracted.",
      hours:"12 Feb 2023 | 12 hours ago",
      butclassname:"success"
   },
   {
      title:"Share A Case Study On One Of Your Customers will be distracted",
      hours:"14 Jan 2023 | 20 hours ago",
      butclassname:"info"
   },


]